// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-46516d64] .el-form-item {\n  margin-bottom: 26px !important;\n}\n[data-v-46516d64] .el-form-item__error {\n  padding-left: 10px !important;\n}\n.minibtn[data-v-46516d64] {\n  padding-top: 0;\n  padding-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
